/**
 * Tiny fixed badge that names the current page.
 * Used so the user and assistant can always agree on which page is on screen.
 */
export function PageLabel({ name }: { name: string }) {
  return <div className="page-label" aria-hidden="true">PAGE · {name}</div>;
}
